import { render } from "./ApplicationLogo.vue?vue&type=template&id=18863262"
const script = {}

import exportComponent from "C:\\Users\\w3fo\\work\\spitta\\terminplaner-oteo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__